import {
  joinRecurringServiceTime,
  recurringTimesForMeridiem,
  splitRecurringServiceTime,
} from '@/api/modules/recurringOrders';
import { OptionSelect } from '@/components/ui/OptionSelect';

export function RecurringServiceTimeFields({
  value,
  onChange,
}: {
  value: string;
  onChange: (next: string) => void;
}) {
  const { meridiem, clock } = splitRecurringServiceTime(value);
  const times = recurringTimesForMeridiem(meridiem);

  return (
    <div className="flex gap-2 mb-3">
      <div className="w-[5.5rem] flex-shrink-0">
        <OptionSelect
          value={meridiem}
          options={[
            { value: 'AM', label: 'AM' },
            { value: 'PM', label: 'PM' },
          ]}
          onChange={(next) => {
            const period = next === 'PM' ? 'PM' : 'AM';
            const options = recurringTimesForMeridiem(period);
            const nextClock = options.includes(clock) ? clock : options[0];
            onChange(joinRecurringServiceTime(nextClock, period));
          }}
        />
      </div>
      <div className="min-w-0 flex-1">
        <OptionSelect
          value={times.includes(clock) ? clock : times[0]}
          options={times.map((item) => ({ value: item, label: item }))}
          onChange={(nextClock) => onChange(joinRecurringServiceTime(nextClock, meridiem))}
        />
      </div>
    </div>
  );
}
